import { useCallback } from 'react';
import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

type UseSelectSlotProps = {
  slotIndex: number;
};

type UseSelectSlotResult = {
  selectedSlotIndex: number;
  selectSlot: (slotIndex: number) => void;
};

type BoundUseSelectSlotResult = {
  isSelected: boolean;
  selectSlot: () => void;
};

export default function useSelectSlot(): UseSelectSlotResult;
export default function useSelectSlot(
  props: UseSelectSlotProps,
): BoundUseSelectSlotResult;
export default function useSelectSlot(
  props?: UseSelectSlotProps,
): UseSelectSlotResult | BoundUseSelectSlotResult {
  const slotIndex = props?.slotIndex ?? -1;

  const {
    dispatch,
    state: { selectedSlotIndex },
  } = useEditSceneModalStateContext();

  const selectSlot = useCallback(
    (index: number) => {
      dispatch({
        type: 'select-slot',
        payload: { slotIndex: index },
      });
    },
    [dispatch],
  );

  const boundSelectSlot = useCallback(() => {
    selectSlot(slotIndex);
  }, [selectSlot, slotIndex]);

  return typeof props === 'undefined'
    ? { selectedSlotIndex, selectSlot }
    : {
        isSelected: selectedSlotIndex === slotIndex,
        selectSlot: boundSelectSlot,
      };
}
